<div class="container-fluid px-3">
    <app-update-partner [partnerDataInput]="partnerData"></app-update-partner>
    <app-list-partner-customers [partnerDataInput]="partnerData"></app-list-partner-customers>
  </div>